export const RESOURCETYPES = {
  RECORDS: 'records',
  PARTIES: 'parties',
  LEGALCASES: 'legalCases',
}
